import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import produce from 'immer';
import { getSearchResult, getStaticContent } from './universalDataFetchers';
import logger from '../common/logger';
import { catalogSliceInitialState, EDC_SLUGS_CATALOG } from '../common/constants';
import { generateCatalogStateStringFromResult } from '../common/utilities';
import { getChildProperty } from '../common/object';

export const fetchCatalogData = createAsyncThunk(
  'catalogData',
  ({
    result, presetFilterString, env, fetchFullFilters, appVersion, filterHistory, perPage,
  }) => getSearchResult({
    catalogResult: result, presetFilterString, env, fetchFullFilters, appVersion, filterHistory, perPage,
  }),
);

export const fetchEditorialData = createAsyncThunk(
  'editorialData',
  ({
    env, isPreview,
  }) => getStaticContent({
    env, isPreview, slugs: EDC_SLUGS_CATALOG,
  }),
);

export const catalogSlice = createSlice({
  name: 'catalogData',
  initialState: catalogSliceInitialState,
  reducers: {
    clearFilters: (state) => {
      const newState = produce(state, (draftState) => {
        draftState.result.filters = draftState?.result?.filters?.map((filter) => ({ ...filter, selections: filter.selections.map((selection) => ({ ...selection, selected: false })) })) || [];
        draftState.result.filterGroups = draftState?.result?.filterGroups?.map((fg) => ({ ...fg, filters: fg.filters.map((filter) => ({ ...filter, selections: filter.selections.map((sel) => ({ ...sel, selected: false })) })) }));
        draftState.filterHistory = {};
      });
      return newState;
    },
    clearResults: (state, action) => {
      const newState = produce(state, (draftState) => {
        draftState.result.cards = [];
        draftState.filterHistory = {};
        draftState.result.status = 'cleared';
        if (action?.payload && Object.keys(action.payload).includes('newTerm')) {
          draftState.result.term = action.payload.newTerm;
        }
        delete draftState.result.totalResults;
      });
      return newState;
    },

  },
  extraReducers: {
    [fetchEditorialData.fulfilled]: (state, action) => {
      const newState = produce(state, (draftState) => {
        draftState.editorial = action?.payload;
      });
      return newState;
    },
    [fetchEditorialData.rejected]: (state, action) => {
      logger.error('Error in fetchEditorialData: ', action.error);
      return state;
    },

    [fetchCatalogData.pending]: (state) => ({
      ...state,
      isLoaderVisible: true,
    }),
    [fetchCatalogData.fulfilled]: (state, action) => {
      const [result, filterHistory] = action?.payload;
      // eslint-disable-next-line no-use-before-define
      // const initialStateString = getStateString({ catalogData: state }, false);
      // eslint-disable-next-line no-use-before-define
      // const newStateString = getStateString({ catalogData: { result } }, false);

      // console.log('Fetch Catalog Data Fulfilled - state: ', `${initialStateString}, ${newStageString}`);
      // if (!state.result.tutorialCards || !state.result.curatedCards || newStateString !== initialStateString || result?.page === 1) { // Not pagination
      // console.log('Fetch Catalog Data Fulfilled - new context');
      const newState = produce(state, (draftState) => {
        draftState.isLoaderVisible = false;
        draftState.result = result;
        draftState.filterHistory = filterHistory;

        // draftState.pagesShown = { tutorial: [result.page], curated: [result.page] };
      });
      return newState;
      // }
      /*
      // Pagination request
      const newState = produce(state, (draftState) => {
        // console.log('Fetch Catalog Data Fulfilled - pagination', action?.payload?.cards, JSON.parse(JSON.stringify(draftState?.result?.cards)));
        draftState.isLoaderVisible = false;
        if (result?.tutorialCards?.length) {
          if (draftState.pagesShown.tutorial.length && result.page < draftState.pagesShown.tutorial[0]) {
            // console.log('Pages shown prepend');
            // Loading earlier page
            draftState.result.tutorialCards = result.tutorialCards.concat(draftState.result.tutorialCards);
          } else {
            // Loading later page data
            // console.log('Pages shown append');
            draftState.result.tutorialCards = draftState.result.tutorialCards.concat(result.tutorialCards);
          }
          draftState.pagesShown.tutorial.push(result.page);
          draftState.pagesShown.tutorial.sort((a, b) => a - b);
        }
        if (result?.curatedCards?.length) {
          if (draftState.pagesShown.curated.length && result.page < draftState.pagesShown.curated[0]) {
            // console.log('Pages shown prepend');
            // Loading earlier page
            draftState.result.curatedCards = result.curatedCards.concat(draftState.result.curatedCards);
          } else {
            // Loading later page data
            // console.log('Pages shown append');
            draftState.result.curatedCards = draftState.result.curatedCards.concat(result.curatedCards);
          }
          draftState.pagesShown.curated.push(result.page);
          draftState.pagesShown.curated.sort((a, b) => a - b);
        }

        draftState.filterHistory = filterHistory;
        // console.log('Pages shown: ', JSON.parse(JSON.stringify(draftState.pagesShown)), action?.payload.page);
      });
      return newState; */
    },
    [fetchCatalogData.rejected]: (state, action) => {
      logger.error('Error in fetchCatalogData: ', action.error);
      return {
        ...state,
        isLoaderVisible: false,
      };
    },
  },
});

// Export auto generated actions that match defined reducers
export const {
  parseUrlFilterState, clearResults, addPageShown, clearFilters,
} = catalogSlice.actions;

// Export getters for store data
export const getCatalogResult = (state) => state.catalogData.result;

export const getFilterHistory = (state) => state.catalogData.filterHistory;

export const getStateString = (state, returnPage) => generateCatalogStateStringFromResult({ result: state.catalogData?.result, returnPage });

export const isLoaderVisible = (state) => state.catalogData.isLoaderVisible;

export const getEditorialData = (state) => getChildProperty(state, 'catalogData.editorial');

// Export reducer by default for import by store config
export default catalogSlice.reducer;
